export * from './admin.service';
import { AdminService } from './admin.service';
export * from './adminPayments.service';
import { AdminPaymentsService } from './adminPayments.service';
export * from './adminProOrganizerRequests.service';
import { AdminProOrganizerRequestsService } from './adminProOrganizerRequests.service';
export * from './adminReports.service';
import { AdminReportsService } from './adminReports.service';
export * from './adminUsersManagement.service';
import { AdminUsersManagementService } from './adminUsersManagement.service';
export * from './app.service';
import { AppService } from './app.service';
export * from './auth.service';
import { AuthService } from './auth.service';
export * from './cgv.service';
import { CgvService } from './cgv.service';
export * from './cgvAcceptance.service';
import { CgvAcceptanceService } from './cgvAcceptance.service';
export * from './cgvAcceptanceHistory.service';
import { CgvAcceptanceHistoryService } from './cgvAcceptanceHistory.service';
export * from './cgvVersions.service';
import { CgvVersionsService } from './cgvVersions.service';
export * from './chats.service';
import { ChatsService } from './chats.service';
export * from './commission.service';
import { CommissionService } from './commission.service';
export * from './commissionHistory.service';
import { CommissionHistoryService } from './commissionHistory.service';
export * from './events.service';
import { EventsService } from './events.service';
export * from './followings.service';
import { FollowingsService } from './followings.service';
export * from './groups.service';
import { GroupsService } from './groups.service';
export * from './health.service';
import { HealthService } from './health.service';
export * from './media.service';
import { MediaService } from './media.service';
export * from './notifications.service';
import { NotificationsService } from './notifications.service';
export * from './organizers.service';
import { OrganizersService } from './organizers.service';
export * from './payments.service';
import { PaymentsService } from './payments.service';
export * from './premiumRole.service';
import { PremiumRoleService } from './premiumRole.service';
export * from './proOrganizerRequests.service';
import { ProOrganizerRequestsService } from './proOrganizerRequests.service';
export * from './profile.service';
import { ProfileService } from './profile.service';
export * from './promos.service';
import { PromosService } from './promos.service';
export * from './requestHistory.service';
import { RequestHistoryService } from './requestHistory.service';
export * from './sparringPartner.service';
import { SparringPartnerService } from './sparringPartner.service';
export * from './sports.service';
import { SportsService } from './sports.service';
export * from './status.service';
import { StatusService } from './status.service';
export * from './systemSetting.service';
import { SystemSettingService } from './systemSetting.service';
export * from './users.service';
import { UsersService } from './users.service';
export const APIS = [AdminService, AdminPaymentsService, AdminProOrganizerRequestsService, AdminReportsService, AdminUsersManagementService, AppService, AuthService, CgvService, CgvAcceptanceService, CgvAcceptanceHistoryService, CgvVersionsService, ChatsService, CommissionService, CommissionHistoryService, EventsService, FollowingsService, GroupsService, HealthService, MediaService, NotificationsService, OrganizersService, PaymentsService, PremiumRoleService, ProOrganizerRequestsService, ProfileService, PromosService, RequestHistoryService, SparringPartnerService, SportsService, StatusService, SystemSettingService, UsersService];
